module.exports = __webpack_public_path__ + "img/aegean_logo.224ecd0d.png";